import EnumDataSource from "../utils/enum-data-source.util";

export const QUICK_FILTER_DEFAULT_TYPE: string = "1";
export const QUICK_FILTER_UNBALANCED_SALES_TYPE: string = "2";
export const QUICK_FILTER_OUTSTANDING_SALES_OVER_90_DAYS_TYPE: string = "3";
export const QUICK_FILTER_READY_TO_BILL_TYPE: string = "4";

const billingQuickFiltersType = {
  [QUICK_FILTER_DEFAULT_TYPE]: "Invoices",
  [QUICK_FILTER_UNBALANCED_SALES_TYPE]: "Outstanding Invoices",
  [QUICK_FILTER_OUTSTANDING_SALES_OVER_90_DAYS_TYPE]:
    "Outstanding Invoices Over 90 Days",
  [QUICK_FILTER_READY_TO_BILL_TYPE]: "Ready To Bill",
};

export const QUICK_FILTER_TYPES = new EnumDataSource(billingQuickFiltersType);
